import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState('tiktok'); // tiktok, vinted, unicolor
    const [customColor, setCustomColor] = useState('#D4AF37'); // Gold default
    const [isDark, setIsDark] = useState(false); // Dark mode state

    const toggleDarkMode = () => setIsDark(!isDark);

    useEffect(() => {
        const root = document.documentElement.style;
        const body = document.body;

        // Reset classes
        body.classList.remove('theme-vinted');

        if (theme === 'tiktok') {
            applyGlobalColor('#00F0FF');
        } else if (theme === 'vinted') {
            body.classList.add('theme-vinted');
            applyGlobalColor('#09B1BA');
        } else if (theme === 'unicolor') {
            applyGlobalColor(customColor);
        }

        // Apply dark mode CSS variables
        if (isDark) {
            root.setProperty('--bg-color', '#0a0a0a');
            root.setProperty('--text-color', '#ffffff');
            root.setProperty('--card-bg', '#111111');
        } else {
            root.setProperty('--bg-color', '#ffffff');
            root.setProperty('--text-color', '#000000');
            root.setProperty('--card-bg', '#f5f5f5');
        }
    }, [theme, customColor, isDark]);

    const applyGlobalColor = (hex) => {
        const root = document.documentElement.style;
        root.setProperty('--primary', hex);
        root.setProperty('--primary-dim', hex + '26'); // ~15% opacity
    };

    return (
        <ThemeContext.Provider value={{ theme, setTheme, customColor, setCustomColor, isDark, toggleDarkMode }}>
            {children}
        </ThemeContext.Provider>
    );
};
